import AlertSvg from 'components/_common/Icons/SVGIcons/AlertSvg';
import { FFL_ROLE_SLUG } from 'config/app.config';
import { placeParamsToURL } from 'helpers/CommonHelper';
import { calculateFormCompletion, normalizeFFLDetails } from 'hooks/useFormCompletion';
import { t } from 'i18next';
import ProfileCompletionBadge from 'modules/admin/components/subModules/AdminFFL/AdminFFLUpdateDetail/Sections/ProfileCompletionBadge';
import React, { useCallback, useMemo, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { adminProfileMain } from 'routes/admin/AdminRoutes';
import {
  userCurrentRoleSlugSelector,
  userFFLInfoSelector,
} from 'store/auth/selectors/authSelectors';
import { useAppSelector } from 'store/hooks';

const ProfileCompletionAlert: React.FC = () => {
  const [show, setShow] = useState(true);

  const userRoleSlug = useAppSelector(userCurrentRoleSlugSelector);
  const fflInfo = useAppSelector(userFFLInfoSelector);
  const hasPermission = userRoleSlug === FFL_ROLE_SLUG;

  const navigate = useNavigate();

  const fflCompletion = useMemo(() => {
    if (userRoleSlug === FFL_ROLE_SLUG && fflInfo) {
      const normalized = normalizeFFLDetails(fflInfo);
      return calculateFormCompletion(normalized);
    }
    return null;
  }, [userRoleSlug, fflInfo]);

  const handleRedirectPage = useCallback(() => {
    navigate(placeParamsToURL(adminProfileMain.path));
    setShow(false);
  }, [navigate]);

  if (!hasPermission) return null;

  if (!show) return null;

  // Nothing left to complete - the alert (and its circle) has no reason to show.
  if (fflCompletion && fflCompletion.percentage >= 100) return null;

  return (
    <div className="profile-completion-alert-wrapper">
      <Alert className="profile-completion-alert d-flex align-items-center justify-content-between rounded-3">
        <div className="alert-left-section d-flex align-items-center">
          <div className="alert-icon-box d-flex align-items-center justify-content-center rounded-circle flex-shrink-0">
            <AlertSvg />
          </div>

          <div className="alert-text-content">
            <div className="alert-title fw-semibold">{t('alert')}</div>
            <div className="alert-message">{t('complete_profile_message')}</div>
          </div>

          <Button
            variant="outline-danger"
            className="update-profile-btn flex-shrink-0"
            onClick={handleRedirectPage}
          >
            {t('update_profile')}
          </Button>
        </div>

        <div className="d-flex align-items-center flex-shrink-0 alert-right-section">
          <ProfileCompletionBadge
            staticPercentage={fflCompletion?.percentage ?? 50}
            staticSections={fflCompletion?.sections}
            isLight
          />
          <button
            type="button"
            className="btn-close"
            onClick={() => setShow(false)}
            aria-label="Close"
          />
        </div>
      </Alert>
    </div>
  );
};

export default ProfileCompletionAlert;
